import type { Maybe } from '@vrplatform/utils';
import { DrawerIssues } from '../_components';
import { useMemo, type ComponentProps } from 'react';
import type { ResponseData } from '@vrplatform/data';

type Transaction = ResponseData<'get:/transactions/{id}'>;

type DrawerIssuesProps = ComponentProps<typeof DrawerIssues>;

export const DepositExpenseTransferIssues = ({
  issues,
  mb,
  type,
}: {
  issues: Maybe<Transaction['issues']>;
  mb?: DrawerIssuesProps['mb'];
  type: 'deposit' | 'expense' | 'transfer' | 'payout';
}) => {
  const config = useMemo<
    Record<
      Transaction['issues'][number]['code'],
      {
        title: string;
        description: string;
      }
    >
  >(() => {
    return {
      line_unassignedAccount: {
        title: 'Line missing account assignment',
        description: `The ${type} has lines without an account assignment. Please review the ${type} and add any missing accounts.`,
      },
      bankAccountLast4Mismatch: {
        title: 'Bank account last four digits mismatch',
        description: `The currently matched bank account last four digits do not match the last four digits of the transaction.`,
      },
    };
  }, [type]);

  return <DrawerIssues issues={issues} config={config} mb={mb} />;
};
